import React from "react";

const Metric = ({ label, value, icon }) => <div className="upcountry-overview__metric"><i className={icon} aria-hidden="true" /><div><span>{label}</span><strong>{value || "—"}</strong></div></div>;

const UpcountryTab = ({ bookingUpcountry }) => {
  const items = Array.isArray(bookingUpcountry) ? bookingUpcountry : [];
  if (items.length === 0) return <div className="booking-tab-empty"><i className="fas fa-route" aria-hidden="true" /><h3>No upcountry service</h3><p>This booking does not have any upcountry distance details.</p></div>;

  return (
    <section className="upcountry-overview">
      {items.map((item, index) => {
        const customerCharge = item.upcountry_paid_by === 2 ? item.upcountry_sf_rate * item.upcountry_distance : 0;
        return <article className="upcountry-overview__card" key={item.id || index}>
          <div className="upcountry-overview__header"><div><span>Travel service {items.length > 1 ? `#${index + 1}` : ""}</span><h2>Upcountry visit</h2></div><span className={`upcountry-overview__badge ${item.is_upcountry === 1 ? "" : "upcountry-overview__badge--muted"}`}>{item.is_upcountry === 1 ? "Upcountry" : "Within city"}</span></div>
          <div className="upcountry-overview__metrics">
            <Metric icon="fas fa-road" label="One-way distance" value={`${item.oneway_distance || 0} KM`} />
            <Metric icon="fas fa-route" label="Upcountry distance" value={`${item.upcountry_distance || 0} KM`} />
            <Metric icon="fas fa-location-dot" label="Pincode" value={item.upcountry_pincode} />
            <Metric icon="fas fa-map" label="Municipal limit" value={`${item.municipal_limit || 0} KM`} />
          </div>
          <div className="upcountry-overview__footer"><div><span>Customer payable</span><strong>₹ {customerCharge}</strong></div><div><span>Payment responsibility</span><strong>{item.upcountry_paid_by === 2 ? "Customer" : "Not applicable"}</strong></div><div><span>Status</span><strong>{item.status || "—"}</strong></div></div>
        </article>;
      })}
    </section>
  );
};

export default UpcountryTab;
